import { Component, OnInit, Input } from '@angular/core';
import { CommercialService } from '../../commercial.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-cq1',
  templateUrl: './cq1.component.html',
  styleUrls: ['./cq1.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq1Component implements OnInit {
  @Input() data: any;
  deviceWidth;
  questions;
  question;
  questionObj;
  question_sub1;
  question_sub2;
  question_sub3;
  question_sub4;
  question_sub5;
  isChecked = false;
  userResponses = [];
  yes_id;
  timer;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
   }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.yes_id = document.getElementById('yes_id');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        if (this.deviceWidth > 768) {
          const question_sub1 = this.question.split('assistant. ');
          this.question_sub1 = question_sub1[0] + ' assistant.';
          const question_sub2 = question_sub1[1].split('upfront ');
          this.question_sub2 = question_sub2[0] + ' upfront';
          const question_sub3 = question_sub2[1].split('later ');
          this.question_sub3 = question_sub3[0] + ' later';
          const question_sub4 = question_sub3[1].split('time. ');
          this.question_sub4 = question_sub4[0] + ' time.';
          this.question_sub5 = question_sub4[1];
        }
      }
    }
    if (this.deviceWidth < 768) {
      if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
        const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
        if (!_.isEmpty(obj)) {
          this.isChecked = true;
          this.yes_id.parentElement.classList.add('active-select');
          this.goNext();
        }
      }
    }
  }

  goNext() {
    if (this.deviceWidth < 768) {
      if (this.isChecked) {
        this.yes_id.parentElement.classList.add('active-select');
        clearTimeout(this.timer);
        this.commercialService.unSelectService({'currentId': this.data});
        this.timer = setTimeout(() => {
          this.next();
        }, 1000);
      } else {
        if (_.contains(this.yes_id.parentElement.classList, 'active-select')) {
          this.yes_id.parentElement.classList.remove('active-select');
        }
        this.commercialService.unSelectService({ 'currentId': this.data });
      }
    }
  }

  next() {
    const obj = {
      com_question_id: this.data,
      fieldName: 'introAccept',
      fieldValue: 'Yes'
    };
    this.commercialService.updateResponses(obj);
    this.commercialService.messageService({ 'currentId': this.data });
  }
}
